export class EConsent{
    body: string;
    signatureDate: string;
    email: string;
    acknowledgementText: string;
    eSignFormNumber: string;
    filingLabel: string;
    filingDate: string;
    headerLine1?: string;
    headerLine2?: string;
    
}